import axios from "@/plugins/axios";

let url = "/api/console/user/integrated-viewers";

// 통합뷰어 계정 관리 (root·admin 전용). 뷰어 관리 API 와 같은 모양이다.
export const integratedViewers = {
    gets(data){
        return axios.get(url, data).then(result => result.data);
    },
    get(data){
        return axios.get(`${url}/${data._id}`).then(result => result.data);
    },
    post(data){
        return axios.post(url, data).then(result => result.data);
    },
    put(data){
        return axios.put(`${url}/${data._id}`, data).then(result => result.data);
    },
    delete(data){
        return axios.delete(`${url}/${data._id}`).then(result => result.data);
    }
}
